import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    group: String,
    handle: String,
    allowDrop: { type: Boolean, default: true },
  };

  connect() {
    this.sortable = new Sortable(this.element, {
      group: {
        name: this.groupValue,
        pull: true,
        put: this.allowDropValue,
      },
      sort: true,
      animation: 150,
      handle: this.handleValue,
      direction: "vertical",
      onEnd: this.handleDrop.bind(this),
      onStart: this.handleDragStart.bind(this),
      onMove: this.handleMove.bind(this),
    });
  }

  disconnect() {
    this.sortable.destroy();
  }

  // eslint-disable-next-line no-unused-vars
  handleMove(_event) {
    return this.isRepositioning;
  }

  getSortableItems() {
    return Array.from(this.element.children).filter((child) =>
      child.hasAttribute("data-sortable-item")
    );
  }

  handleDragStart(event) {
    this.isRepositioning = event.originalEvent.altKey || false;

    // const sortableItems = this.getSortableItems();
    // this.oldIndex = sortableItems.indexOf(event.item);
  }

  handleDrop(event) {
    // const sortableItems = this.getSortableItems();
    // const actualNewIndex = sortableItems.indexOf(event.item);

    const dropTarget = event.originalEvent.target;
    const targetItem = dropTarget.closest("[data-resource-sku-handle]");

    // const actualOldIndex = this.oldIndex;
    // const targetItem = sortableItems[actualNewIndex];

    // Find the resource-sku-handle element in the target
    // const targetElement = targetItem?.querySelector("[data-resource-sku-handle]");

    const { isRepositioning } = this;
    this.isRepositioning = false;
    // this.oldIndex = null;

    const eventName = isRepositioning
      ? "drag-drop:reposition"
      : "drag-drop:ended";

    const bookingResourceSkuIds = this.getSortableItems().map((item) => {
      const element = item.querySelector("[data-resource-sku-handle]");
      return element?.dataset?.bookingResourceSkuId;
    });

    const customEvent = new CustomEvent(eventName, {
      detail: {
        draggedItem: event.item,
        dropTarget: targetItem || event.originalEvent.target,
        originalEvent: event,
        bookingResourceSkuIds,
      },
      bubbles: true,
    });

    this.element.dispatchEvent(customEvent);
  }
}
